export const dayStart = d => {
	let date = createDate(d);
	return dateToString(date)
}
export const dayEnd = d => {
	let date = createDate(d);
	date.setDate(date.getDate() + 1)
	return dateToString(date)
}
export const weekStart = d => {
	let date = createDate(d);
	let weekstart = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1 - date.getDay());
	return dateToString(weekstart);
}
export const weekEnd = d => {
	let date = createDate(d);
	let weekend = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 7 - date.getDay());
	return dateToString(weekend);
}
export const monthStart = d => {
	let date = createDate(d);
	let month = date.getMonth();
	let year = date.getFullYear();
	return dateToString(new Date(year, month, 1, 0))
}
export const monthEnd = d => {
	let date = createDate(d);
	let month = date.getMonth();
	let year = date.getFullYear();
	return dateToString(new Date(year, month + 1, 1, 0))
}
export const yearStart = d => {
	let date = createDate(d);
	let year = date.getFullYear();
	return dateToString(new Date(year, 0, 1, 0))
}
export const yearEnd = d => {
	let date = createDate(d);
	let year = date.getFullYear();
	return dateToString(new Date(year + 1, 0, 1, 0))
}
export const monthDays = d => {
	let date = new Date(d.getFullYear(), d.getMonth() + 1, 1);
	return (Number)(addDay(date, -1).toLocaleDateString().split('/')[2])
}
export const addDay = (d, num) => {
	let date = createDate(d);
	date.setDate(date.getDate() + num)
	return date
}

export const currentDay = d => {
	let date = createDate(d);
	return Number(date.toLocaleDateString().split('/')[2])
}

export const perDay = d => {
	let date = createDate(d);
	date.setDate(date.getDate() - 1)
	return date
}
export const nextDay = d => {
	let date = createDate(d);
	date.setDate(date.getDate() + 1)
	return date
}
export const perMonth = d => {
	let date = createDate(d);
	date.setMonth(date.getMonth() - 1)
	return date
}
export const nextMonth = d => {
	let date = createDate(d);
	date.setMonth(date.getMonth() + 1)
	return date
}

export const perYear = d => {
	let date = createDate(d);

	return new Date((date.getFullYear() - 1) + '')
}
export const nextYear = d => {
	let date = createDate(d);

	return new Date((date.getFullYear() + 1) + '')
}


function createDate(d) {
	return new Date(d.getTime())
}

function dateToString(d) {
	return d.toLocaleDateString().replace(/\//g, '-') + 'T00:00:00Z'
}


export function dateFormat(fmt, date) {
	let ret;
	const opt = {
		"Y+": date.getFullYear().toString(), // 年
		"m+": (date.getMonth() + 1).toString(), // 月
		"d+": date.getDate().toString(), // 日
		"H+": date.getHours().toString(), // 时
		"M+": date.getMinutes().toString(), // 分
		"S+": date.getSeconds().toString(), // 秒
		// 有其他格式化字符需求可以继续添加，必须转化成字符串
	};
	for (let k in opt) {
		ret = new RegExp("(" + k + ")").exec(fmt);
		if (ret) {
			fmt = fmt.replace(ret[1], ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, "0"));
		}
	}
	return fmt;
}
export function formatDateFn(date) {
	let myyear = date.getFullYear();
	let mymonth = date.getMonth() + 1;
	let myweekday = date.getDate();
	if (mymonth < 10) {
	  mymonth = "0" + mymonth;
	}
	if (myweekday < 10) {
	  myweekday = "0" + myweekday;
	}
	return (myyear + "-" + mymonth + "-" + myweekday);

}
//计算周
export function getAppointedDate(date,optType, optPageNum) {
	let obj = {}
      let now = date; //当前日期
      let nowDayOfWeek = now.getDay(); //今天本周的第几天
      let nowDay = now.getDate(); //当前日
      let nowMonth = now.getMonth(); //当前月
      let nowYear = now.getFullYear(); //当前年
      let lastMonth = nowMonth - 1;
      let startDate = '';
      let endDate = '';
      if (optType == 1) {
        startDate = formatDateFn(new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1 - (7 *
          optPageNum)))
        endDate = formatDateFn(new Date(nowYear, nowMonth, nowDay + 7 - nowDayOfWeek - (7 * optPageNum)))
      } else if (optType == 2) {
        startDate = formatDateFn(new Date(nowYear, lastMonth + 1 - (1 * optPageNum), 1))
        endDate = formatDateFn(new Date(nowYear, lastMonth + 1 - (1 * optPageNum), getMonthDays(
          nowYear, lastMonth + 1 - (1 * optPageNum))))
      }
      return obj = {
        startDate: startDate,
        endDate: endDate
      }
}

export function getDate(datestr) {
	var temp = datestr.split("-");
	if (temp[1] === '01') {
		temp[0] = parseInt(temp[0],10) - 1;
		temp[1] = '12';
	} else {
		temp[1] = parseInt(temp[1],10) - 1;
	}
	//new Date()的月份入参实际都是当前值-1
	var date = new Date(temp[0], temp[1], temp[2]);
	return date;
}
//获取周的日期处理
export function getDiffDate(start,end) {
	var startTime = getDate(start);
	var endTime = getDate(end);
	var dateArr = [];
	while ((endTime.getTime() - startTime.getTime()) >= 0) {
		var year = startTime.getFullYear();
		var month = (startTime.getMonth()+1).toString().length === 1 ? "0" + (parseInt(startTime.getMonth().toString(),10) + 1) : (startTime.getMonth() + 1);
		var day = startTime.getDate().toString().length === 1 ? "0" + startTime.getDate() : startTime.getDate();
		dateArr.push(year + "-" + month + "-" + day);
		startTime.setDate(startTime.getDate() + 1);
	}
	return dateArr;

}